import { render, staticRenderFns } from "./info-modal-nearmiss.vue?vue&type=template&id=ca17d398&scoped=true"
import script from "./info-modal-nearmiss.vue?vue&type=script&lang=js"
export * from "./info-modal-nearmiss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca17d398",
  null
  
)

export default component.exports